import api from "../../../api";

class validation {

    constructor() {
        this.product = null;
        this.suppliers = null;
        this.oldProduct = null;
        this.dimensions = [];
    }

    getSupplierPrefix() {

        for (let key in this.suppliers) {
            if (this.suppliers[key].id === this.product.supplier_id) {
                return this.suppliers[key].prefix;
            }
        }

        return "";
    }

    /**
     *
     * @returns {boolean}
     */
    validate(product, oldProduct, dimensions, suppliers, translate, isRequiredField) {

        return new Promise((resolve) => {

            this.product = product;
            this.suppliers = suppliers;
            this.oldProduct = oldProduct;
            this.dimensions = dimensions;

            let errors = {};

            if (!this.validateCode()) {
                errors.code = translate("tools.general.errors.code");
            }
            if (!this.validateSupplierPrefix()) {
                errors.prefix = translate("tools.general.errors.prefix") + (this.product.requestType === 'newQuoteProduct' ? `KA-${this.getSupplierPrefix()}` : this.getSupplierPrefix());
            }
            if (isRequiredField('code2') && !this.validateCode2()) {
                errors.code2 = translate("tools.general.errors.code2");
            }
            if (!this.validateCode3()) {
                errors.code3 = translate("tools.general.errors.code3");
            }
            if (!this.validateName()) {
                errors.name = translate("tools.general.errors.name");
            }
            if (isRequiredField('description') && !this.validateDescription()) {
                errors.description = translate("tools.general.errors.description");
            }
            if (isRequiredField('manufacturerName') && !this.validateManufacturer()) {
                errors.manufacturerName = translate("tools.general.errors.manufacturerName");
            }
            if (isRequiredField('volume') && !this.validateVolume()) {
                errors.volume = translate("tools.general.errors.volume");
            }
            if (isRequiredField('variations') && !this.validateVariations()) {
                errors.variations = translate("tools.general.errors.variations");
            }

            if (isRequiredField('group_id') && !product.group_id) {
                errors.group_id = translate("tools.general.errors.group");
            }

            if (isRequiredField('category_id') && !product.category_id) {
                errors.category_id = translate("tools.general.errors.category");
            }
            if (isRequiredField('country_id') && !product.country_id) {
                errors.country_id = translate("tools.general.errors.country");
            }
            if (!product.supplier_id) {
                errors.supplier_id = translate("tools.general.errors.supplier");
            }
            if (!product.vatrate_id) {
                errors.vatrate_id = translate("tools.general.errors.vatrate");
            }

            if (this.product.createMatrix) {
                if (!this.validateCreateMatrix()) {
                    errors.createMatrix = translate("tools.general.errors.createMatrix");
                }
            }

            switch (this.product.requestType) {

                case "create":
                    api.checkUnique(this.product.code)
                        .then((unique) => {
                            if (!unique) {
                                errors.code = translate("tools.general.errors.unique");
                            }
                            resolve(errors);
                        }, () => {
                            errors.code = translate("tools.general.errors.unique");
                            resolve(errors);
                        });
                    break;
                case "newQuoteProduct":
                    api.checkUnique(this.product.code)
                        .then((unique) => {
                            if (!unique) {
                                errors.code = translate("tools.general.errors.unique");
                            }
                            resolve(errors);
                        }, () => {
                            errors.code = translate("tools.general.errors.unique");
                            resolve(errors);
                        });
                    break;
                case "newVintage":
                    api.checkUnique(this.product.code)
                        .then((unique) => {
                            if (!unique) {
                                errors.code = translate("tools.general.errors.unique");
                            }

                            if (this.product.matrixCode !== "") {
                                api.checkUnique(this.product.matrixCode)
                                    .then((unique) => {
                                        if (!unique) {
                                            errors.matrixCode = translate("tools.general.errors.matrixCode");
                                        }
                                        resolve(errors);
                                    }, () => {
                                        errors.matrixCode = translate("tools.general.errors.matrixCode");
                                        resolve(errors);
                                    });
                            } else {
                                resolve(errors);
                            }
                        }, () => {
                            errors.code = translate("tools.general.errors.unique");
                            resolve(errors);
                        });
                    break;
                case "edit":
                    if (oldProduct.code !== product.code) {
                        api.checkUnique(this.product.code)
                            .then((unique) => {
                                if (!unique) {
                                    errors.code = translate("tools.general.errors.unique");
                                }
                                resolve(errors);
                            }, () => {
                                errors.code = translate("tools.general.errors.code");
                                resolve(errors);
                            });
                    } else {
                        resolve(errors);
                    }
                    break;

                default:
                    resolve(errors);
                    break;

            }

        });


    }

    validateVariations() {
        if (this.product.createMatrix) {
            return true;
        }
        if (!this.product.parent_product || !this.product.parent_product.child_products) {
            return true;
        }
        if (!this.product.variations) {
            return true;
        }

        const variations = this.product.variations.map((v) => {
            return v.id;
        });
        const siblings = this.product.parent_product.child_products;

        for (let key in siblings) {
            let matches = [];
            if (this.product.requestType === "edit" && siblings[key].id === this.product.id) {
                continue;
            }
            if (!siblings[key].variations) {
                continue;
            }
            for (let variationKey in siblings[key].variations) {
                if (variations.includes(siblings[key].variations[variationKey].id)) {
                    matches.push(siblings[key].variations[variationKey]);
                }
            }
            if (matches.length === variations.length) {
                return false;
            }
        }

        return true;
    }

    validateSupplierPrefix() {
        let prefix = this.getSupplierPrefix();
        if (!prefix) {
            return true;
        }
        if(this.product.requestType === 'newQuoteProduct'){
            prefix = "KA-" + prefix;
        }
        return this.product.code.substring(0, prefix.length) === prefix;
    }

    validateCreateMatrix() {

        if (this.product.variations[0].id === 1) {
            return false;
        }
        if (this.product.variations[1].id === 1) {
            return false;
        }
        if (this.product.variations[2].id === 1) {
            return false;
        }
        if (this.product.oldProductVariations[0].id === 1) {
            return false;
        }
        if (this.product.oldProductVariations[1].id === 1) {
            return false;
        }
        if (this.product.oldProductVariations[2].id === 1) {
            return false;
        }
        if (this.product.matrixCode === "" || this.product.matrixCode.length < 4) {
            return false;
        }
        if (this.product.matrixCode === this.product.code){
            return false;
        }

        return true;
    }

    /**
     *
     * @returns {boolean}
     */
    validateCode() {
        let vintage = this.product.variations.reduce((a, b) => {
            if (this.dimensions[b.dimension_id].name === "Jahrgang") {
                return b.code;
            }
            return a;
        }, null);
        if (/^\d+$/.test(vintage) && vintage.length === 4) {
            console.log("is HK?", "HK" === this.product.code.substring(this.product.code.length - 2));
            console.log("is HK substring?", this.product.code.substring(this.product.code.length - 4, this.product.code.length - 2));

            if ("HK" === this.product.code.substring(this.product.code.length - 2)) {
                if (vintage.substring(2) !== this.product.code.substring(this.product.code.length - 4, this.product.code.length - 2)) {
                    return false;
                }

            } else {
                if (vintage.substring(2) !== this.product.code.substring(this.product.code.length - 2)) {
                    return false;
                }
            }


        }
        if (this.product.requestType === "newVintage") {
            return this.oldProduct.code !== this.product.code;
        }

        return true;
    }

    /**
     *
     * @returns {boolean}
     */
    validateCode2() {
        if (this.product.code2.length === 0) {
            return true;
        }
        return this.product.code2.split(",")
            .reduce((a, b) => {
                if (a === false) {
                    return false;
                }
                return /^\d+$/.test(b);

            }, true);
    }

    /**
     *
     * @returns {boolean}
     */
    validateCode3() {
        return this.product.code3.length > 0 && this.product.code.includes(this.product.code3);
    }


    /**
     *
     * @returns {boolean}
     */
    validateName() {
        return this.product.name.length > 3;
    }

    /**
     *
     * @returns {boolean}
     */
    validateDescription() {
        return this.product.description.length > 0;
    }

    /**
     *
     * @returns {boolean}
     */
    validateManufacturer() {
        return this.product.manufacturerName.length > 0;
    }


    /**
     *
     * @returns {boolean}
     */
    validateVolume() {

        const volume = Number.parseInt(this.product.volume, 10);


        if (!Number.isInteger(volume)) {
            return false;
        }

        let volumeFromDimension = this.product.variations.reduce((a, b) => {
            if (this.dimensions[b.dimension_id].name === "Volumen") {
                return b.code;
            }
            return a;
        }, null);

        if (volumeFromDimension === null) {
            return true;
        }

        return Number.parseInt(volumeFromDimension, 10) === Number.parseInt(volume, 10);
    }


}


export default new validation();





// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/validation.js